import { Component, OnInit } from '@angular/core';
import { Message} from 'primeng/primeng';
import { ConfirmationService} from 'primeng/primeng';
import { SelectItem} from 'primeng/primeng';
import { CompanyService} from '../services/company.service';
import { UserService} from '../services/user.service';

@Component({
  selector: 'app-company',
  templateUrl: './company.component.html',
  styleUrls: ['./company.component.css'],
  providers: [ConfirmationService]
})
export class CompanyComponent implements OnInit {

  msgs: Message[] = [];
  company: any;
  companies : any [];
  displayAdd: boolean = false;
  displayEdit: boolean = false;
  status: SelectItem[];
  blockedDocument: boolean = false;
  statusFilter: SelectItem[];

  constructor(private companyService : CompanyService,private userService : UserService,
    private confirmationService: ConfirmationService) { }

  ngOnInit() {
    this.init();
    this.statusFilter = [
            {label: 'Todos', value: null },
            {label: 'Habilitado', value: 'H'},
            {label: 'Inhabilitado', value: 'I'}
        ];
    this.status = [
            {label: 'Habilitado', value: 'H', icon: 'fa fa-check-square-o'},
            {label: 'Inhabilitado', value: 'I', icon: 'fa fa-square-o'}
        ];
  }
  init(){
    this.companies = [];

    if(this.userService.userLoged.idProfile == 1){
      this.companyService.findAll().then(data => {
        let response: any = data;
        response.companies.forEach(item => {
          this.companies.push(item);
        });
      }).catch(err =>{
          this.msgs = [{severity:'error', summary:'ERROR', detail:err}];
      });
    }else{
      this.companyService.findByUser(this.userService.userLoged.idUser).then(data => {
        let response: any = data;
        response.companies.forEach(item => {
          this.companies.push(item);
        });
      }).catch(err =>{
          this.msgs = [{severity:'error', summary:'ERROR', detail:err}];
      });
    }
    this.company = {status:"H",idUserOwner:this.userService.userLoged.idUser};
    this.displayAdd = false;
    this.displayEdit = false;
  }

  showAdd(){
    this.displayAdd = true;
  }

  showEdit(company:any){
    this.company=company;
    this.displayEdit = true;
  }

  hide(){
    this.company = {status:"H",idUserOwner:this.userService.userLoged.idUser};
    this.displayAdd = false;
    this.displayEdit = false;
  }

  add(){
    this.blockedDocument = true;
    this.companyService.create(this.company).then(data =>{
      let response: any = data;
        if(response.status == 'OK'){
          this.init();
          this.msgs = [{severity:'info', summary:'INFO', detail:'Registro insertado exitosamente'}];
        }else{
          this.msgs = [{severity:'error', summary:'ERROR', detail:response.message}];
        }
        this.blockedDocument = false;
    }).catch(err =>{
        this.msgs = [{severity:'error', summary:'ERROR', detail:err}];
        this.blockedDocument = false;
    });
  }

  edit(){
    this.blockedDocument = true;
    this.companyService.edit(this.company).then(data =>{
      let response: any = data;
        if(response.status == 'OK'){
          this.init();
          this.msgs = [{severity:'info', summary:'INFO', detail:'Registro modificado exitosamente'}];
        }else{
          this.msgs = [{severity:'error', summary:'ERROR', detail:response.message}];
        }
        this.blockedDocument = false;
    }).catch(err =>{
        this.msgs = [{severity:'error', summary:'ERROR', detail:err}];
        this.blockedDocument = false;
    });
  }

  del(id: number){
    this.confirmationService.confirm({
            message: 'Esta seguro de eliminar el registro seleccionado?',
            header: 'Confirmación',
            icon: 'fa fa-trash',
            accept: () => {
                this.blockedDocument = true;
                this.companyService.remove(id).then(data =>{
                  let response: any = data;
                    if(response.status == 'OK'){
                      this.init();
                      this.msgs = [{severity:'info', summary:'INFO', detail:'Registro eliminado exitosamente'}];
                    }else{
                      this.msgs = [{severity:'error', summary:'ERROR', detail:response.message}];
                    }
                    this.blockedDocument = false;
                }).catch(err =>{
                    this.msgs = [{severity:'error', summary:'ERROR', detail:err}];
                    this.blockedDocument = false;
                });
            }
        });
  }
}



// WEBPACK FOOTER //
// ./src/app/company/company.component.ts